import richText from "utilities/richText"
import cn from "classnames"
import DynamicComponent from ".."

export default function TwoColumn({ blok }) {
  const styles = cn("py-6 lg:py-10 flex flex-col md:flex-row gap-4", {
    "text-white": blok.background_color === "primary",
  })

  return (
    <div className={styles}>
      <div className="md:basis-1/3">
        <h2 className={cn({ "text-primary": blok.background_color === "white" })}>{blok.heading}</h2>

        {blok.subheading_content ? (
          <div className="mt-6 mb-4">
            {blok.subheading_content.map((blok) => (
              <DynamicComponent key={blok._uid} blok={blok} />
            ))}
          </div>
        ) : null}
      </div>
      <div className="md:basis-2/3">{richText(blok.content)}</div>
    </div>
  )
}
